import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useSWR from 'swr';
import RootLanding from '../../components/layouts/RootLanding';
import { getFetcherPublic } from '../../services/api';
import { BilahCari, LabelSeksi, Paginasi, Wadah } from '../../components/fragments/landing/publik/Elemen';
import { KartuKontenDb, KerangkaKartu } from '../../components/fragments/landing/publik/Seksi';
import { TOPIK } from '../../components/fragments/landing/publik/topikPublik';

/*
 * Halaman "Berita dan Artikel" (frame Figma "Berita"): berita dan artikel
 * digabung dalam satu daftar, disaring per topik. Dipakai untuk /berita dan
 * /artikel. Kedua tabel diambil sekaligus lalu dipaginasi di browser karena
 * API-nya terpisah per tabel; jumlah kontennya kecil (puluhan).
 */
const PER_HALAMAN = 9;
const BATAS_AMBIL = 500;

export default function BeritaPage() {
    const [params, setParams] = useSearchParams();
    const kategori = params.get('kategori');
    const [ketikan, setKetikan] = useState('');
    const [cari, setCari] = useState('');
    const [halaman, setHalaman] = useState(1);

    const filter = `${kategori ? `&categoryName=${encodeURIComponent(kategori)}` : ''}${cari ? `&name=${encodeURIComponent(cari)}` : ''}`;
    const { data: berita, isLoading: a } = useSWR(
        `/api/content/search-news?page=1&limit=${BATAS_AMBIL}&sortBy=createdAt${filter}`,
        getFetcherPublic
    );
    const { data: artikel, isLoading: b } = useSWR(
        `/api/content/search-articles?page=1&limit=${BATAS_AMBIL}&sortBy=createdAt${filter}`,
        getFetcherPublic
    );

    const semua = useMemo(
        () =>
            [...(berita?.data ?? []), ...(artikel?.data ?? [])].sort(
                (x, y) => new Date(y.createdAt) - new Date(x.createdAt)
            ),
        [berita, artikel]
    );
    const jumlahHalaman = Math.ceil(semua.length / PER_HALAMAN);
    const tampil = semua.slice((halaman - 1) * PER_HALAMAN, halaman * PER_HALAMAN);

    useEffect(() => setHalaman(1), [kategori, cari]);

    const pilihKategori = (k) => {
        const baru = new URLSearchParams(params);
        if (k) baru.set('kategori', k);
        else baru.delete('kategori');
        setParams(baru, { replace: true });
    };

    return (
        <RootLanding>
            <section className="bg-pb-halaman">
                <Wadah className="flex flex-col gap-8 pb-16 pt-12 lg:px-[120px]">
                    <div className="flex flex-col gap-3">
                        <LabelSeksi>Berita</LabelSeksi>
                        <h1 className="!font-body text-[32px] font-semibold tracking-[-1px] text-pb-ink md:text-4xl">
                            Berita dan Artikel
                        </h1>
                    </div>
                    <BilahCari
                        nilai={ketikan}
                        setNilai={setKetikan}
                        onCari={() => setCari(ketikan.trim())}
                        placeholder="Cari berdasarkan judul berita atau artikel"
                        kategori={TOPIK.map((t) => t.kategori)}
                        terpilih={kategori}
                        setTerpilih={pilihKategori}
                    />
                    {a || b ? (
                        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3 lg:gap-x-8">
                            {[0, 1, 2].map((i) => (
                                <KerangkaKartu key={i} />
                            ))}
                        </div>
                    ) : tampil.length === 0 ? (
                        <p className="rounded-md bg-white p-10 text-center font-body text-sm text-pb-teks">
                            {cari ? 'Tidak ada berita atau artikel yang cocok dengan pencarian Anda.' : 'Belum ada berita atau artikel untuk kategori ini.'}
                        </p>
                    ) : (
                        <div className="grid gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
                            {tampil.map((item, i) => (
                                <KartuKontenDb key={item.id} item={item} indeks={i} oranye />
                            ))}
                        </div>
                    )}
                    <Paginasi halaman={halaman} jumlahHalaman={jumlahHalaman} setHalaman={setHalaman} />
                </Wadah>
            </section>
        </RootLanding>
    );
}
